import { render, staticRenderFns } from "./distribution_list.vue?vue&type=template&id=409f6ae2&scoped=true"
import script from "./distribution_list.vue?vue&type=script&lang=ts"
export * from "./distribution_list.vue?vue&type=script&lang=ts"
import style0 from "./distribution_list.vue?vue&type=style&index=0&id=409f6ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409f6ae2",
  null
  
)

export default component.exports